import store from "store";
import { ISubject } from "store/types";

export const getCurrentSubjectName = (id: number | null | undefined) => {
  if (!id) {
    return "";
  }
  const { subjects } = store.getState();
  const subject: ISubject = subjects.find((s: ISubject) => s.id === id);
  return (subject && subject.name) || "";
};

export const getCurrentSubjectCategory = (id: number | null | undefined) => {
  if (!id) {
    return -1;
  }
  const { subjects } = store.getState();
  const subject: ISubject = subjects.find((s: ISubject) => s.id === id);
  if (subject) {
    return subject.categoryId;
  }
  return -1;
};
